export function isAuthExpiredError(e) {
    return e instanceof Error && "authExpired" in e && e.authExpired === true;
}
